/** The example spreadsheet served from `public/authoring/`. */
export const SAMPLE_AUTHORING_TEMPLATE_URL = "/authoring/sample_authoring_template.xlsx";

/** One authoring check: a library prompt whose `name` is the heading. `id` is set for a stored prompt. */
export interface CheckDraft {
  id?: string;
  heading: string;
  prompt: string;
}

export const EMPTY_CHECK: CheckDraft = { heading: "", prompt: "" };

/** Drops blank rows and trims the rest; what gets sent to the backend. */
export const cleanChecks = (checks: readonly CheckDraft[]): CheckDraft[] =>
  checks
    .filter(check => check.heading.trim() && check.prompt.trim())
    .map(check => ({ ...check, heading: check.heading.trim(), prompt: check.prompt.trim() }));
